import { NgModule } from '@angular/core';

import { SupportNumberRoutingModule } from './support-number-routing.module';
import { SupportNumberComponent } from './support-number.component';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { CustomizationService } from 'src/services/customization.service';
import { PageLayoutModule } from 'src/app/belender/page-layout/page-layout.module';
import { MaterialModule } from 'src/app/shared/modules/materia.module';
import { AssetUrlModule } from 'src/pipes/asset-url.module';


@NgModule({
  declarations: [SupportNumberComponent],
  imports: [
    SupportNumberRoutingModule,
    MatProgressSpinnerModule,
    PageLayoutModule,
    MaterialModule,
    AssetUrlModule
  ],
  providers: [
    CustomizationService
  ],
})
export class SupportNumberModule { }
